<div class="cg-dialog">
  <h2
    data-test="leave-chcp-dialog-header"
    class="cg-dialog__header cg-dialog__header--modal"
  >
    {{ data.heading ? data.heading : 'You are now leaving CignaforHCP.com' }}
  </h2>

  <mat-dialog-content>
    <div class="cg-margin-bottom-xl" data-test="leave-chcp-content">
      {{ data.content }}
    </div>

    <div data-test="btn-continue" class="cg-button-group cg-margin-bottom-sm">
      <ng-container *ngIf="isAuth0; else isISAM">
        <a
          cignaButton="primary"
          [routerLink]="'/linkrouter'"
          [queryParams]="{
            key: data.partnerName
          }"
          target="_blank"
          rel="noopener"
          (click)="leaveChcpDialogRef.close()"
          [cignaTrackClicks]="
            data.analytics
              ? [
                  'trackEventOther',
                  data.analytics.linkName,
                  data.analytics.prop13,
                  data.analytics?.extra
                ]
              : []
          "
        >
          Continue
        </a>
      </ng-container>
      <ng-template #isISAM>
        <a
          cignaButton="primary"
          [href]="data.link"
          target="_blank"
          rel="noopener"
          (click)="leaveChcpDialogRef.close()"
          [cignaTrackClicks]="
            data.analytics
              ? [
                  'trackEventOther',
                  data.analytics.linkName,
                  data.analytics.prop13,
                  data.analytics?.extra
                ]
              : []
          "
        >
          Continue
        </a>
      </ng-template>
    </div>
  </mat-dialog-content>
</div>
